import { ErrorCatcher } from '../../tools/error-catcher';
import { StyledViewStyleButton } from './view-style-button.styles';
import { ListViewStyleIcon } from '../../components/icons-library/list-view-style';
import { GalleryViewStyleIcon } from '../../components/icons-library/gallery-view-style';
import { useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';

type ButtonProps = {
    type: 'list' | 'gallery';
    text: string;
    onClick: (args?: any) => void;
    isActive: boolean;
};

export const ViewStyleButton = (props: ButtonProps) => {
    const { localize } = useContext(AppContext);

    const icon = props.type === 'list' 
        ? <ListViewStyleIcon /> 
        : <GalleryViewStyleIcon />;

    return (
        <ErrorCatcher componentName="ListStyleButton">
            <StyledViewStyleButton 
                onClick={props.onClick}
                isActive={props.isActive}
                aria-label={props.type === 'list'
                    ? localize('switch-to-list-view', 'Switch to list view')
                    : localize('switch-to-gallery-view', 'Switch to gallery view')
                }
            >
                {icon}
                <span>{props.text}</span>
            </StyledViewStyleButton>
        </ErrorCatcher>
    );
};
